import { Link } from 'react-router-dom';

export function OnboardingPage(): JSX.Element {
  return (
    <section className="onboarding-page">
      <div className="onboarding-hero">
        <span>Breathly intake</span>
        <h1>Build a breath-confidence plan from evidence, not panic.</h1>
        <p>
          Breathly starts by separating likely odor sources, anxiety/checking loops, available
          evidence, and close-contact goals. The dashboard then turns that into a 7-day aid plan.
        </p>
        <div className="onboarding-actions">
          <Link to="/dashboard">Start diagnostic intake</Link>
          <Link to="/login">Sign in</Link>
        </div>
      </div>
      <div className="onboarding-grid">
        {[
          ['1', 'Severity map', 'Score odor concern, anxiety, avoidance, and halitophobia watch.'],
          [
            '2',
            'Source map',
            'Track tongue coating, dry mouth, reflux, gums, tonsils, sinus, diet.',
          ],
          ['3', 'Evidence locker', 'Record photo/report/feedback placeholders for R2 attachment.'],
          ['4', 'Weekly plan', 'Run one focused routine trial instead of changing everything.'],
        ].map(([num, title, copy]) => (
          <article key={title}>
            <strong>{num}</strong>
            <h2>{title}</h2>
            <p>{copy}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
